import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from '../../../../shared/comum.module';
import { translateLoaderNBS } from '../../../../shared/translate-loader/translateLoader';
import { AnaliseMargemBi02FiltroComponent } from './analise-margem-bi02-filtro/analise-margem-bi02-filtro.component';
import { AnaliseMargemBi02ListaGridComponent } from './analise-margem-bi02-lista/analise-margem-bi02-lista-grid/analise-margem-bi02-lista-grid.component';
import { AnaliseMargemBi02ListaComponent } from './analise-margem-bi02-lista/analise-margem-bi02-lista.component';
import { AnaliseMargemBi02Service } from './analise-margem-bi02-service/analise-margem-bi02.service';
import { AnaliseMargemBi02Component } from './analise-margem-bi02.component';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    NgbModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    AnaliseMargemBi02Component,
    AnaliseMargemBi02ListaGridComponent
  ],
  declarations: [
    AnaliseMargemBi02Component,
    AnaliseMargemBi02ListaComponent,
    AnaliseMargemBi02FiltroComponent,
    AnaliseMargemBi02ListaGridComponent
  ],
  providers: [
    AnaliseMargemBi02Service
  ]
})
export class AnaliseMargemBi02Module { }
